import { section } from "@/glow";
import { qsa } from "@fluorescent/dom";
import CountdownTimer from "@/lib/countdown-timer";
import { animateStandard, shouldAnimate } from "@/lib/animation";

const selectors = {
  "timer": "[data-countdown-timer]",
};

section("countdown-banner", {
  onLoad() {
    const timers = qsa(selectors.timer, this.container);
    this.countdownTimers = [];

    timers.forEach(timer => {
      this.countdownTimers.push(CountdownTimer(timer));
    });

    if (shouldAnimate(this.container)) {
      this.animateCountdownBanner = animateStandard(this.container);
    }
  },

  onUnload() {
    this.animateCountdownBanner?.destroy();
    this.countdownTimers.forEach(countdownTimer => countdownTimer.destroy());
  },
});
